// apps/web/src/components/subscriptions/SubscriptionsManager.tsx
// Plan subscription management.

import { ManagerPage } from '../platform/ManagerPage.js';
import type { Subscription } from '../../types/platform.js';

export function SubscriptionsManager() {
  return (
    <ManagerPage
      title="Subscriptions"
      listPath="/api/v1/subscriptions"
      listKey="subscriptions"
      createLabel="New Subscription"
      className="subscriptions-manager"
      renderItem={(raw) => {
        const s = raw as Subscription;
        return (
          <div className="manager-card" key={s.id}>
            <h3>{s.plan}</h3>
            <p className="status-badge">{s.status}</p>
            <p>Renews {s.renewsAt ?? '—'}</p>
            <div className="actions">
              <button className="btn btn-secondary">View</button>
              <button className="btn btn-warning">Pause</button>
              <button className="btn btn-primary">Resume</button>
            </div>
          </div>
        );
      }}
    />
  );
}